<template>
	<div class="search-cont">
		<div class="zhezhao"></div>
		<div class="center">
			<div class="cont-right">
				<span class="close" @click="close">
					<img src="../assets/img/close.png" alt />
				</span>
				<div class="logo">
					<img src="../assets/img/logo.png" />
				</div>
				<div class="box">
					<input type="text" placeholder="请输入关键词" autofocus="autofocus" v-model="keyWord"
						v-on:keyup.enter="searchResult"/>
				</div>
				<p># 热门搜索 #</p>
				<ul class="sea-list">
					<li v-for="(item,index) in content" :class="n == index ? 'active' : '' " :key="index"
						@click="trans(index,item.keyWrod)">{{item.keyWrod}}</li>
				</ul>
			</div>
		</div>
	</div>
</template>
<script>
	import $ from "jquery";
	import eventBus from '@/common/eventBus'
	export default {
		data() {
			return {
				content: [],
				n: 0,
				keyWord: ""
			};
		},
		mounted() {
			this.getWords();
		},
		methods: {
			close() {
				this.$parent.$data.seek = false;
			},
			trans(i, v) {
				this.n = i;
				this.keyWord = v;
				this.searchResult();
			},
			getWords() {
				// 获取热门搜索
				this.$http
					.get("/api/003-hotWordList")
					.then(res => {
						if (res.status == 200 && res.data.code == 0) {
							this.content = res.data.rows;
						}
					})
					.catch(err => {
						console.log(err);
					});
			},
			searchResult() {
				//搜索页面
				this.$parent.$data.seek = false;
				this.$router.push({
					path: "/searchResult",
					query: {
						keyWord: this.keyWord
					}
				});
				
				eventBus.$emit('updateSearchData', this.keyWord)
			}
		}
	};
</script>
<style scoped>

</style>
